import gpsApi from '@/api/gps.api'

export const gpsService = (function () {
  'use strict'


  /**
   * Devuelve los datos para la tabla del ABM de gps
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} headers
   */
  async function findAll(pageSize, pageNumber, headers = false) {
    try {
      /*
      if (pageSize > 0 && pageNumber > 0) {
        const response = await gpsApi.findAll(pageSize, pageNumber, headers)
        return response.data
      } else {
        return {
          data: [],
          headers: []
        }
      }
      */
      const response = await gpsApi.findAll(undefined, undefined, headers)
      return response.data
    } catch (exception) {
      console.log(exception)
      return {
        data: [],
        headers: []
      }
    }
  }

  /**
   * Devuelve el total de gps de la collection para el paginador de la tabla del ABM
   */
  async function getTotal() {
    try {
      const response = await gpsApi.getTotal()
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Historial de un gps
   * @param {*} id
   */
  async function getHistory(id, headers = false) {
    try {
      const response = await gpsApi.getHistory(id, headers)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Estados posibles para un gps
   */
  async function getStates() {
    try {
      const response = await gpsApi.getStates()
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Marcas de gps
   */
  async function getBrands() {
    try {
      const response = await gpsApi.getBrands()
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Modelos de una marca
   * @param {*} brandId
   */
  async function getModels(brandId) {
    try {
      const response = await gpsApi.getModels(brandId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
  * Validar la unicidad del unitId
  * @param {*} unitId
  */
  async function validateUnitId(unitId) {
    try {
      if (unitId) {
        const response = await gpsApi.validateUnitId(unitId)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
      console.log(exception)
      return false
    }
  }

  /**
   * Para eliminar un gps
   */
  async function deleteOne(id) {
    /*
    try {
        const response = await gpsApi.deleteOne(id)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await gpsApi.deleteOne(id)
    return response.data
  }

  /**
   * Para eliminación múltiple
   */
  async function deleteMany(ids) {
    /*
    try {
        const response = await gpsApi.deleteMany(ids)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await gpsApi.deleteMany(ids)
    return response.data
  }


  /**
   * Crea una nueva cosa en la collection
   * @param {*} gps
   */
  async function create(gps) {
    /*
    try {
      const response = await gpsApi.create(gps)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await gpsApi.create(gps)
    return response.data
  }

  /**
   * Actualiza una cosa existente en la collection
   * @param {*} gps
   */
  async function update(gps) {
    /*
    try {
      const response = await gpsApi.update(gps)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await gpsApi.update(gps)
    return response.data
  }

  /**
   * Para obtener los gps para el selector de modulo gestya dentro del abm de equipos
  */
  async function getAllForSelectorThingAbm() {
    const result = await gpsApi.getAllForSelectorThingAbm()
    return result.data
  }

  /**
   * Para obtener la información del gps para utilizar en el ABM de equipos
   */
  async function getForThingABM(gpsId) {
    const result = await gpsApi.getForThingABM(gpsId)
    return result.data
  }

  /**
   * Devuelve todos los modulos de comunicación para el selector del ABM
   */
  async function getcommunicationModules() {
    try {
      const response = await gpsApi.getcommunicationModules()
      return response.data
    } catch (exception) {
      console.error(exception)
      return []
    }
  }

  return {
    findAll,
    getTotal,
    getHistory,
    getStates,
    getBrands,
    getModels,
    deleteOne,
    deleteMany,
    create,
    update,
    validateUnitId,
    getAllForSelectorThingAbm,
    getForThingABM,
    getcommunicationModules,
  }
})()
